import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "progress"]
  static values  = { dismissAfter: Number }

  connect() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.show()
      })
    })

    if (this.hasDismissAfterValue) {
      if (this.hasProgressTarget) {
        this.progressTarget.style.transition = `width ${this.dismissAfterValue}ms linear`
        this.progressTarget.style.width = "100%"
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.progressTarget.style.width = "0%"
          })
        })
      }
      this.dismissTimer = setTimeout(() => this.close(), this.dismissAfterValue)
    }
  }

  disconnect() {
    clearTimeout(this.dismissTimer)
  }

  show() {
    if (!this.hasCardTarget) return
    this.cardTarget.style.transition = "transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease"
    this.cardTarget.classList.remove("translate-x-full", "opacity-0")
  }

  close() {
    clearTimeout(this.dismissTimer)
    if (!this.hasCardTarget) return
    this.cardTarget.style.transition = "opacity 0.3s ease, transform 0.3s ease"
    this.cardTarget.classList.add("opacity-0")
    this.cardTarget.style.transform = "scale(0.95)"
    setTimeout(() => this.element.remove(), 350)
  }
}
